import {
    faBell,
    faExclamationTriangle,
    faHandHoldingUsd,
    faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Suspense, useContext, useState } from 'react';
import { Nav, Spinner, Tab } from 'react-bootstrap';
import { BranchesContext } from '../../context/BranchesContext';
import { Branches } from '../Branches';
import { Payments } from './Payments';
import { Reminders } from './Reminders';
import { Troubles } from './Troubles';
import ErrorBoundary from '../ErrorBoundary';
import { ErrorComponent } from '../ErrorComponent';
import { useTranslation } from 'react-i18next';

export const TasksManager = () => {
    const { branches } = useContext(BranchesContext);
    const [activeTab, setActiveTab] = useState('branches');
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [hasExpiringReminder, setHasExpiringReminder] = useState(false);
    const activeTabErrorText =
        activeTab === 'payments'
            ? t('payments')
            : activeTab === 'troubles'
                ? t('troubles')
                : activeTab === 'reminders'
                    ? t('reminders')
                    : t('dashboard');

    return (
        <div className='task-manager-container h-100'>
            <div className='task-manager-content'>
                <Tab.Container id='left-tabs-example' defaultActiveKey='first'>
                    <Nav
                        variant='pills'
                        className={`flex-row w-100 flex-nowrap task-manager-nav justify-content-between`}
                    >
                        <Nav.Item
                            className='w-50  justify-content-center'
                            role='button'
                            onClick={() => setActiveTab('branches')}
                        >
                            <Nav.Link eventKey='first' className=' text-center py-2'>
                                <FontAwesomeIcon icon={faMapMarkerAlt} size='lg' className='fa-fw' />
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className='w-50 justify-content-center'
                            role='button'
                            onClick={() => setActiveTab('payments')}
                        >
                            <Nav.Link eventKey='second' className=' text-center py-2'>
                                <FontAwesomeIcon icon={faHandHoldingUsd} size='lg' className='fa-fw' />
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className='w-50 justify-content-center'
                            role='button'
                            onClick={() => setActiveTab('troubles')}
                        >
                            <Nav.Link eventKey='third' className=' text-center py-2'>
                                <FontAwesomeIcon icon={faExclamationTriangle} size='lg' className='fa-fw' />
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className='w-50 justify-content-center '
                            role='button'
                            onClick={() => setActiveTab('reminders')}
                        >
                            <Nav.Link className='text-center py-2' eventKey='fourth'>
                                <FontAwesomeIcon
                                    icon={faBell}
                                    size='lg'
                                    className='fa-fw'
                                    color={hasExpiringReminder ? 'red' : 'black'}
                                />
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className='pt-1 tab-content position-relative d-flex flex-column flex-grow-1 min-h-0'>
                        <Tab.Pane eventKey='first'>
                            <Branches branches={branches} activeTab={activeTab} selectable></Branches>
                        </Tab.Pane>
                        <ErrorBoundary valueToObserve={activeTab} fallback={<ErrorComponent errorText={activeTabErrorText} />}>
                            <Suspense
                                fallback={
                                    <div className='w-100 d-flex justify-content-center'>
                                        <Spinner animation='border' />
                                    </div>
                                }
                            >
                                {activeTab === 'payments' && <Payments></Payments>}
                                {activeTab === 'troubles' && <Troubles></Troubles>}
                                {activeTab === 'reminders' && (
                                    <Reminders {...{ setHasExpiringReminder }}></Reminders>
                                )}
                            </Suspense>
                        </ErrorBoundary>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </div>
    );
};
